import { render, staticRenderFns } from "./other-upload.vue?vue&type=template&id=438969c0&scoped=true&"
import script from "./other-upload.vue?vue&type=script&lang=js&"
export * from "./other-upload.vue?vue&type=script&lang=js&"
import style0 from "./other-upload.vue?vue&type=style&index=0&lang=less&"
import style1 from "./other-upload.vue?vue&type=style&index=1&id=438969c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438969c0",
  null
  
)

export default component.exports